export default "__VITE_ASSET__CnEfXgnK__"